import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AuthPageLayout } from '../shared/components/containers/AuthPageLayout';
import { BrandHeader } from '../shared/components/headers/BrandHeader';
import { BasicAnchor } from '../shared/components/links/BasicAnchor';

interface OwnProps {
}

const Heading = styled.div`
  font-weight: 600;
  font-size: 1.3em;
  margin-bottom: 5px;
`;

const Explanation = styled.div`
  color: ${(props) => props.theme.colors.mutedText};
  margin-bottom: 20px;
`;

const NotFoundPage = (props: OwnProps) => {
  const {} = props;
  const { t } = useTranslation();

  return (
    <AuthPageLayout>
      <BrandHeader/>
      <Heading>{t('notFound.heading')}</Heading>
      <Explanation>{t('notFound.explanation')}</Explanation>
      <BasicAnchor url="/">{t('notFound.backHome')}</BasicAnchor>
    </AuthPageLayout>
  );
};

export {
  NotFoundPage,
};
